import { useEffect, useState } from "react";

// Phones and tablets (any width under 1280px, or a touch-first screen) use full-screen windows instead of floating ones.
const COMPACT = "(max-width: 1279px), (pointer: coarse)";
const WIDE = "(min-width: 1024px) and (orientation: landscape)";

const read = () => {
  if (typeof window === "undefined" || !window.matchMedia) return { compact: false, panel: false };
  const compact = window.matchMedia(COMPACT).matches;
  return { compact, panel: compact && window.matchMedia(WIDE).matches };
};

export function useCompactLayout() {
  const [state, setState] = useState(read);
  useEffect(() => {
    const update = () => setState(read());
    const lists = [COMPACT, WIDE].map((q) => window.matchMedia(q));
    lists.forEach((m) => m.addEventListener("change", update));
    window.addEventListener("orientationchange", update);
    return () => {
      lists.forEach((m) => m.removeEventListener("change", update));
      window.removeEventListener("orientationchange", update);
    };
  }, []);
  return state;
}

// Hand a window's payload to a brand-new browser tab (/admin/w/:kind) so it opens there on its own.
export function popOutWindow(win) {
  const key = Math.random().toString(36).slice(2, 10);
  try {
    localStorage.setItem(`nex_popout_${key}`, JSON.stringify({ kind: win.kind, payload: win.payload || {} }));
  } catch {
    /* payload too large for storage — the tab opens with an empty payload */
  }
  window.open(`/admin/w/${encodeURIComponent(win.kind)}?k=${key}`, "_blank", "noopener");
}
